interface GlossaryTerm {
  term: string
  definition: string
}

const terms: GlossaryTerm[] = [
  {
    term: 'GSSP (getServerSideProps)',
    definition:
      'Next.js server function that runs on every request. Used on /s to prefetch search results before HTML is sent.',
  },
  {
    term: 'GSP (getStaticProps)',
    definition:
      'Next.js server function that runs at build time or on-demand. Used for category PLPs and CMS landing pages.',
  },
  {
    term: 'ISR (Incremental Static Regeneration)',
    definition:
      'Static pages that revalidate in the background after a time interval or webhook trigger, without a full rebuild.',
  },
  {
    term: 'Bridge',
    definition:
      'The worldwidegolfqa.faststore-unbxd-bridge VTEX IO app. Owns Unbxd credentials and returns FastStore-compatible search results.',
  },
  {
    term: 'tenant-graphql',
    definition:
      'VTEX GraphQL aggregator at /_v/private/graphql/v1. Dispatches faststoreSearch to the bridge transparently.',
  },
  {
    term: 'DTO (Data Transfer Object)',
    definition:
      'FsSearchResult — the standardized payload shape returned by the bridge and consumed by the storefront.',
  },
  {
    term: 'Hydration (catalog)',
    definition:
      'Enriching Unbxd product IDs with full VTEX catalog data: prices, availability, images, and variants.',
  },
  {
    term: 'SWR',
    definition:
      'Client-side stale-while-revalidate cache. Keeps previous search results visible while fetching updates.',
  },
  {
    term: 'SearchSsrPayload',
    definition:
      'Server-prefetched search data embedded in page props. Seeds the client gallery and filter sidebar on first paint.',
  },
  {
    term: 'Circuit breaker',
    definition:
      'Protection mechanism that stops calling the bridge after repeated failures (5 in 60s), falling back to VTEX IS for 30s.',
  },
  {
    term: 'Query.search override',
    definition:
      'FastStore GraphQL resolver replacement that routes search to the bridge when ENABLE_UNBXD_SEARCH is true.',
  },
  {
    term: 'forceInteractive',
    definition:
      'Rendering mode that ships real section HTML instead of empty JavaScript placeholders — critical for SEO and no-JS users.',
  },
]

/**
 * Renders the glossary term list.
 */
export function renderGlossary(): string {
  const items = terms
    .map(
      (t) =>
        `<div class="glossary__item">
          <h4 class="glossary__term">${t.term}</h4>
          <p class="glossary__def">${t.definition}</p>
        </div>`
    )
    .join('')

  return `<div class="glossary" data-component="glossary">${items}</div>`
}
